import _ from 'lodash'
import { get, each, find, debounce } from 'lodash';
import Vue from 'vue';

// import store from '@/store';
// import router from '@/router';
// import NestedSet from '@/nested-set-lib';

import ShopApi from '@/extensions/shop/store/api/shop';
import { findPrice } from '@/filters';

// initial state
const state = {
    products: undefined, // TODO: null
    messages: [],
    cart: {
        initialised: false,
        articles: [],
        qty: 0,
        tax: 0,
        sum: 0
    },
    visibleProducts: [],
    focusedMedia: null,
    customer: undefined, // TODO: null
    categories: undefined // TODO: null
};

// getters
const getters = {
    products: state => state.products,
    messages: state => state.messages,
    cart: state => state.cart,
    customer: state => state.customer,
    activeProduct: state => {
        let activeProduct = null;
        if (state.visibleProducts && state.visibleProducts.length) {
            const sorted = _.orderBy(state.visibleProducts, 'position', 'asc');
            activeProduct = sorted[0];
        }

        return activeProduct;
    },
    focusedMedia: state => state.focusedMedia,
    categories: state => state.categories
};

// mutations
const mutations = {
    insertProducts(state, { products }) {
        // let pagination = {
        //     pageInfo: Object.freeze(products.pageInfo),
        //     items: []
        // };
        // if (products.items && products.items.length) {
        //     products.items.forEach((item, i) => {
        //         item.position = i + 1;
        //         const product = Object.freeze(item);
        //         pagination.items.push(product);
        //     });
        // }
        // Vue.set(state, 'products', pagination);

        if (products.items && products.items.length) {
            products.items.forEach((product, i) => {
                product.position = i + 1;
            });
        }
        Vue.set(state, 'products', products);
    },
    insertCategories(state, categories) {
        Vue.set(state, 'categories', Object.freeze(categories));
    },
    // initCart(state, member) {
    //     if (!state.cart.initialised) {
    //         if (member) {
    //             let customer, cartArticles = undefined;
    //             customer = get(member, 'customer');

    //             if (customer) {
    //                 Vue.set(state, 'customer', customer);
    //             }
    //             cartArticles = get(customer, 'shoppingCart.articles');

    //             if (cartArticles && cartArticles.length) {
    //                 Vue.set(state.cart, 'articles', cartArticles);
    //             } else {
    //                 let localStorageItems = JSON.parse(localStorage.getItem('cart'));
    //                 if (localStorageItems && localStorageItems.length) {
    //                     Vue.set(state.cart, 'articles', localStorageItems.articles);
    //                 }
    //             }
    //             Vue.set(state.cart, 'initialised', true);
    //         }
    //     }
    // },
    setCustomer(state, customer) {
        Vue.set(state, 'customer', Object.freeze(customer));
    },
    setCart(state, cart) {
        Vue.set(state, 'cart', cart);
    },
    setCartInitialised(state, status) {
        Vue.set(state.cart, 'initialised', status);
    },
    // updateCart(state, articles) {
    //     // Vue.set(state.cart, 'articles', Object.freeze(articles));
    //
    //     ShopApi.saveShoppingCartLocal(articles);
    //     ShopApi.debouncedSaveShoppingCart(articles);
    //
    //     // if (articles.length > 0) {
    //     //     let qty = 0;
    //     //     each(articles, article => {
    //     //         qty = qty + parseInt(article.pivot.qty);
    //     //     });
    //     //     Vue.set(state.cart, 'qty', qty);
    //     // }
    // },
    // clearCart(state) {
    //     Vue.set(state, 'cart', { articles: [], initialised: true });
    // },
    addVisibleProduct(state, product) {
        if (!state.visibleProducts.find(el => el.id === product.id)) {
            const length = state.visibleProducts.length;
            Vue.set(state.visibleProducts, length, product);
        }
    },
    removeVisibleProduct(state, product) {
        const i = _.findIndex(state.visibleProducts, { id: product.id });
        if (i >= 0) Vue.delete(state.visibleProducts, i);
    },
    clearVisibleProducts(state) {
        Vue.set(state, 'visibleProducts', []);
    },
    setFocusedMedia(state, { product, media }) {
        if (media === 'main') {
            let elements = _.get(product, 'media') || [];
            elements = _.orderBy(elements, 'position');

            if (elements.length) {
                const video = elements.find(el => el.type === 'video' && el.video !== null);
                const image = elements.find(el => el.type === 'image' && el.image !== null);

                media = video || image;
                if (media) {
                    product = _.cloneDeep(product);
                    delete product.media;

                    media.product = product;
                    state.focusedMedia = media;
                } else {
                    state.focusedMedia = null;
                }
            }
        } else if (media && media.type) {
            product = _.cloneDeep(product);
            delete product.media;

            media.product = product;
            state.focusedMedia = media;
        } else {
            state.focusedMedia = null;
        }
    },
    removeFocusedMedia(state) {
        state.focusedMedia = null;
    },
    addArticleToProduct(state, { product, articles }) {
        let products = _.get(state.products, 'items') || [];
        const i = _.findIndex(products, el => parseInt(el.id) === parseInt(product));
        if (i >= 0) {
            Vue.set(state.products.items[i], 'articles', articles);
            Vue.set(state.products.items, i, Object.freeze(state.products.items[i]));
        }
    }
};

// actions
const actions = {
    fetchProductsPaginated({ commit }, payload) {
        return ShopApi.fetchProductsPaginated(payload);
    },
    fetchProductsWithArticlesPaginated({ commit }, payload) {
        return ShopApi.fetchProductsPaginated(payload, true);
    },
    fetchProduct({ commit }, payload) {
        return ShopApi.fetchProduct(payload);
    },
    saveCart({ state }) {
        ShopApi.saveShoppingCartLocal(state.cart.articles);

        const articles = state.cart.articles.map(article => {
            return {
                id: article.id,
                pivot: {
                    qty: article.qty
                }
            };
        });
        ShopApi.debouncedSaveShoppingCart(articles);
    },
    createPurchase({ dispatch, commit }, payload) {
        return ShopApi.createPurchase(payload).then(purchase => {
            if (purchase && purchase.id && parseInt(purchase.id) > 0) {
                dispatch('clearCart')
            } else {
                const message = {
                    id: _.uniqueId(),
                    title: 'Fehler',
                    text: 'Beim Übertragen Ihrer Bestellung ist ein Fehler aufgetreten.',
                    type: 'danger',
                    autoclose: 5000
                };
                commit('addMessage', message, { root: true });
                throw new Error('Error creating purchase');
            }
        });
    },
    fetchCategories({ commit }, payload) {
        return ShopApi.fetchCategories(payload);
    },
    fetchProductArticles({ commit }, product) {
        return ShopApi.fetchArticles({ product }).then(articles => {
            // find product in pagination
            // and add the articles to it
            commit('addArticleToProduct', { product, articles });
        });
    },
    // fetchShoppingCart({ commit }, payload) {
    //     return ShopApi.fetchShoppingCart(payload).then(data => console.log(data));
    // },
    addArticleToCart({ commit, dispatch, state, rootState }, article) {
        let articles = _.cloneDeep(state.cart.articles);
        const index = _.findIndex(articles, { id: article.id });

        if (index >= 0) {
            ++articles[index].qty;
        } else {
            articles.push({
                id: article.id,
                qty: 1
            });
        }

        const defaultCustomerGroup = _.get(rootState, 'setup.CMS.shop.defaultCustomerGroup');
        const defaultTax = _.get(rootState, 'setup.CMS.shop.defaultTax');
        const customer = _.get(state, 'customer');

        const price =
            findPrice(article, customer, defaultCustomerGroup, true) ||
            findPrice(article.product, customer, defaultCustomerGroup, true);

        const taxRate = _.get(price, 'tax.value') || defaultTax.value;
        const tax = _.round((price.value * taxRate) / (100 + taxRate), 2);

        const cart = {
            qty: state.cart.qty + 1,
            sum: state.cart.sum + price.value,
            tax: state.cart.tax + tax,
            articles
        };

        commit('setCart', cart);
        dispatch('saveCart');
    },
    removeArticleFromCart({ commit, dispatch, state, rootState }, article) {
        let articles = _.cloneDeep(state.cart.articles);
        const index = _.findIndex(articles, { id: article.id });

        if (index >= 0) {
            --articles[index].qty;

            if (articles[index].qty <= 0) articles.splice(index, 1);

            const defaultCustomerGroup = _.get(rootState, 'setup.CMS.shop.defaultCustomerGroup');
            const defaultTax = _.get(rootState, 'setup.CMS.shop.defaultTax');
            const customer = _.get(state, 'customer');

            const price =
                findPrice(article, customer, defaultCustomerGroup, true) ||
                findPrice(article.product, customer, defaultCustomerGroup, true);

            const taxRate = _.get(price, 'tax.value') || defaultTax.value;
            const tax = _.round((price.value * taxRate) / (100 + taxRate), 2);

            const cart = {
                qty: state.cart.qty - 1,
                sum: state.cart.sum - price.value,
                tax: state.cart.tax - tax,
                articles
            };

            commit('setCart', cart);
            dispatch('saveCart');
        }
    },
    updateArticleQtyInArticle({ commit, dispatch, state, rootState }, { article, qty }) {
        let articles = _.cloneDeep(state.cart.articles);
        const index = _.findIndex(articles, { id: article.id });

        qty = parseInt(qty);
        if (isNaN(qty)) qty = 0;
        else if (qty > 1000) qty = 1000;

        let q = qty;
        if (index >= 0) {
            q = qty - articles[index].qty;
            articles[index].qty = qty;

            if (articles[index].qty <= 0) articles.splice(index, 1);
        } else if (qty > 0) {
            articles.push({
                id: article.id,
                qty
            });
        }

        const defaultCustomerGroup = _.get(rootState, 'setup.CMS.shop.defaultCustomerGroup');
        const defaultTax = _.get(rootState, 'setup.CMS.shop.defaultTax');
        const customer = _.get(state, 'customer');

        const price =
            findPrice(article, customer, defaultCustomerGroup, true) ||
            findPrice(article.product, customer, defaultCustomerGroup, true);

        const taxRate = _.get(price, 'tax.value') || defaultTax.value;
        const tax = _.round((price.value * taxRate) / (100 + taxRate), 2);

        qty = state.cart.qty + q;

        const cart = {
            qty,
            sum: state.cart.sum + price.value * q,
            tax: state.cart.tax + tax * q,
            articles
        };

        commit('setCart', cart);
        dispatch('saveCart');
    },
    initCart({ commit, state }, member) {
        if (!state.cart.initialised && member) {
            const customer = get(member, 'customer');
            if (customer) commit('setCustomer', customer);

            const articles = ShopApi.getShoppingCartLocal();
            const data = get(customer, 'shoppingCart');

            if (data) {
                const articles = data.articles.map(article => {
                    return {
                        id: article.id,
                        qty: article.pivot.qty
                    };
                });
                const cart = {
                    sum: get(data, 'grandTotal') || 0,
                    qty: get(data, 'articleQtySum') || 0,
                    tax: get(data, 'taxSum') || 0,
                    articles
                };
                commit('setCart', cart);
                ShopApi.saveShoppingCartLocal(cart.articles);
            } else if (articles && articles.length) {
                ShopApi.fetchShoppingCart(articles).then(data => {
                    const cart = {
                        sum: get(data, 'grandTotal') || 0,
                        qty: get(data, 'articleQtySum') || 0,
                        tax: get(data, 'taxSum') || 0,
                        articles
                    };
                    ShopApi.saveShoppingCartLocal(cart.articles);
                });
            }
            commit('setCartInitialised', true);
        }
    },
    clearCart({ commit, dispatch }, state) {
        commit('setCart', {
            articles: [],
            qty: 0,
            sum: 0,
            tax: 0
        });
        dispatch('saveCart');
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
